<template>
<div class="chapter">
<div class="inner_page">
<div class="forward">
<div class="cite">
<p class="blockquote"><span><a id="page_0005"></a><br/><br/><br/><br/>We express our gratitude to Allen Black, Ron Cox, Brian Faust, Josh Fleer, Spencer Furby, and Jonathan Woodall for their careful reading of the manuscripts in various stages of development; to Jody Fleischhut for her personable work with the Seminar, and to Jim and Caye Randolph for enabling so many of the Seminars participants.</span></p>
<br/><br/>
<p class="blockquote"><span>To the memories of Marvelyn Fleer and Leo and Mabel Perleth, my first community of faith and whose unconditional love sustains me long after their deaths. - David Fleer</span></p>
<br/><br/>
<p class="blockquote"><span>To the memories of J. P. Sanders, E. W. McMillan, and Delane Way who, as a young preacher, were my first elders and mentors in the faith and who showed me how to “run with endurance.” - Dave Bland</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780891128793_Part04.vue?84097b3e